import type { XZReport } from "@/androidPlugins/IReports"

const { formatToMerchantCurrencyString } = useCurrency()

export const getPositiveXZReportHeader = (
  reportName: string
) => {
  const { name } = useTenant()
  const { serialNumber } = useDevice()

  return (
    getDataLine(name.value, null, true) +
    getBlankLines(1) +
    getDataLine(serialNumber.value, "S/N", true) +
    getDataLine(
      new Date().toLocaleDateString(),
      null,
      true
    ) +
    getBlankLines(1) +
    getDataLine(reportName, null, true) +
    getBlankLines(1)
  )
}

export const formatPositiveZReport = (
  report: XZReport
): string => {
  if (report.nativeReceiptLines.length > 0) {
    const header = getDataLine(
      "Resets to zero after end of banking window",
      null,
      true
    )
    return formatReceipt(report.nativeReceiptLines, header)
  }

  const body =
    getPositiveXZReportHeader("Z REPORT") +
    getDataLine("Resets to zero every time", null, true) +
    getBlankLines(1) +
    getDoubleDataLine(
      "Sales",
      report.saleCount.toString(),
      formatToMerchantCurrencyString(report.saleAmount)
    ) +
    getDoubleDataLine(
      "Completions",
      report.completionCount.toString(),
      formatToMerchantCurrencyString(
        report.completionAmount
      )
    ) +
    getDoubleDataLine(
      "Refunds",
      report.refundCount.toString(),
      formatToMerchantCurrencyString(report.refundAmount)
    ) +
    getDataLine(
      formatToMerchantCurrencyString(report.totalAmount),
      "TOTAL"
    ) +
    getBlankLines(1) +
    "Inclusive Of \n" +
    getDoubleDataLine(
      "GRATUITY",
      report.gratuityCount.toString(),
      formatToMerchantCurrencyString(report.gratuityAmount)
    ) +
    getDoubleDataLine(
      "CASHBACK",
      report.cashbackCount.toString(),
      formatToMerchantCurrencyString(report.cashbackAmount)
    )

  return body
}
